import { useParams } from 'react-router-dom';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { CopyLink, Group } from 'apps/shared/scripts/components';

const ManualPreference = () => {
  const { cardId } = useParams();
  return (
    <ContentCard>
      <Group
        label={'Published Link'}
        description={
          'Once the card is published, you may share the link below with the recipient manually.'
        }
      >
        <CopyLink url={`${process.env.REACT_APP_URL!}/${cardId}`} />
      </Group>
    </ContentCard>
  );
};

ManualPreference.displayName = 'ManualPreference';

export default ManualPreference;
